<template>
    <div class="row" v-show="aBanners.length > 0">
        <div class="col-12">
            <div id="carouselHeaderBanners" class="carousel slide box-shadow-light bb-0 mt-m1" data-ride="carousel">
                <ol class="carousel-indicators carousel-indicators-n">
                    <li data-target="#carouselHeaderBanners"
                        v-for="(banner, index) in aBanners"
                        :class="[ index == 0 ? 'active' : '' ]"
                        :data-slide-to="index"
                        :key="'bl_' + index">
                    </li>
                </ol>
                <div class="carousel-inner">
                    <div class="carousel-item"
                         v-for="(banner, index) in aBanners"
                         :class="[ index == 0 ? 'active' : '', banner.url ? 'cursor-pointer' : '' ]"
                         :key="'b_' + index">

                        <img class="d-block w-100"
                             :src="banner.path"
                             :alt="banner.file_name"
                             @click="openBannerUrl(banner)">

                    </div>
                </div>
                <a class="carousel-control-prev carousel-left-arrow hidden-mobile" href="#carouselHeaderBanners" role="button" data-slide="prev">
                    <span class="btn-slide">
                        <i class="fe-arrow-left-circle fs-30"></i>
                    </span>
                    <span class="sr-only">Anterior</span>
                </a>
                <a class="carousel-control-next carousel-right-arrow hidden-mobile" href="#carouselHeaderBanners" role="button" data-slide="next">
                    <span class="btn-slide">
                        <i class="fe-arrow-right-circle fs-30"></i>
                    </span>
                    <span class="sr-only">Siguiente</span>
                </a>
            </div>
        </div>
    </div>
</template>

<script>
import fileRootPathMixin from '../../../mixins/fileRootPathMixin';

export default {

    mixins: [fileRootPathMixin],

    data() {

        return {

            aBanners: [],

        };

    },

    mounted() {

        this.loadBanners();

    },

    methods: {

        loadBanners() {

            let banners = null;

            if (this.isMobile) {

                banners = $.parseJSON(localStorage.getItem('banners_mobile'));

            } else {

                banners = $.parseJSON(localStorage.getItem('banners'));

            }

            if (banners && banners.length > 0) {

                this.aBanners = banners.map((banner) => {

                    banner.path = this.fileRootPath + banner.path;

                    return banner;

                });

                $('#carouselHeaderBanners').carousel({
                    interval: 7000,
                });

            }

        },

        openBannerUrl({ url, opening_type = '_self' }) {

            if (url) {

                window.open(url, opening_type);

            }

        },

    },

};
</script>
